module.exports = __webpack_public_path__ + "img/left_prod_box_mask.0a4aba06.png";